var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0117188,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9999 43.2466C40.8179 43.2466 47.6017 38.2426 50.9791 35.2279C52.3399 34.0132 52.3399 31.9834 50.9791 30.7688C47.6017 27.754 40.8179 22.75 32.9999 22.75C25.1818 22.75 18.3981 27.754 15.0206 30.7688C13.6598 31.9834 13.6598 34.0132 15.0206 35.2279C18.3981 38.2426 25.1818 43.2466 32.9999 43.2466ZM32.9999 40.1483C36.9488 40.1483 40.1499 36.9472 40.1499 32.9983C40.1499 29.0495 36.9488 25.8483 32.9999 25.8483C29.0511 25.8483 25.8499 29.0495 25.8499 32.9983C25.8499 36.9472 29.0511 40.1483 32.9999 40.1483Z",
    fill: "#14705F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.23c68d9f8f7f139f2158f572dc6af5a5.svg";
export { ForwardRef as ReactComponent };